module.exports = {
	"id": "wdwd.trade.close",
	"description": "订单关闭",
	"meta": {
		"oauth": true
	},
	"requests": {
		"urls": [
			{
				"name": "正式环境",
				"http": "http://openapi.wdwd.com/api/gateway?method=wdwd.trade.close",
				"https": "https://openapi.wdwd.com/api/gateway?method=wdwd.trade.close"
			},
			{
				"name": "沙箱环境",
				"http": "http://openapi.sandbox.wdwd.com/api/gateway?method=wdwd.trade.close",
				"https": "https://openapi.sandbox.wdwd.com/api/gateway?method=wdwd.trade.close"
			}
		],
		"params": {
			"share": [],
			"private": [
				{
					"name": "tid",
					"type": "string",
					"required": true,
					"description": "订单ID"
				}
			]
		}
	},
	"responses": {
		"exceptions": [],
		"params": [
			{
				"name": "trade",
				"type": "trade",
				"description": "订单结构，只包含tid和modified"
			}
		]
	},
	"structure": [
		{
			"name": "invoice",
			"params": [
				{
					"name": "invoice_content",
					"type": "string",
					"enumerable": false,
					"description": "发票内容"
				},
				{
					"name": "invoice_id",
					"type": "string",
					"enumerable": false,
					"description": "发票ID"
				},
				{
					"name": "invoice_title",
					"type": "string",
					"enumerable": false,
					"description": "发票抬头"
				},
				{
					"name": "invoice_title_type",
					"type": "string",
					"enumerable": false,
					"description": "发票抬头类型 person:个人 company:企业"
				},
				{
					"name": "invoice_type",
					"type": "string",
					"enumerable": false,
					"description": "发票类型 normal:正常发票 vat:增值发票"
				},
				{
					"name": "receiver_address",
					"type": "string",
					"enumerable": false,
					"description": "收票人详细地址"
				},
				{
					"name": "receiver_location",
					"type": "string",
					"enumerable": false,
					"description": "收票人地区  XX省-XX市-XX区"
				},
				{
					"name": "receiver_mobile",
					"type": "string",
					"enumerable": false,
					"description": "收票人手机号"
				},
				{
					"name": "receiver_name",
					"type": "string",
					"enumerable": false,
					"description": "发票收货地类型"
				},
				{
					"name": "tid",
					"type": "string",
					"enumerable": false,
					"description": "订单ID"
				},
				{
					"name": "vat_info",
					"type": "value_added_tax",
					"enumerable": false,
					"description": "增值发票信息"
				}
			]
		},
		{
			"name": "payment",
			"params": [
				{
					"name": "buyer_account",
					"type": "string",
					"enumerable": false,
					"description": "购买account"
				},
				{
					"name": "modified",
					"type": "string",
					"enumerable": false,
					"description": ""
				},
				{
					"name": "outer_no",
					"type": "string",
					"enumerable": false,
					"description": "支付网关的内部交易单号"
				},
				{
					"name": "pay_fee",
					"type": "string",
					"enumerable": false,
					"description": "\t 本次支付金额"
				},
				{
					"name": "pay_time",
					"type": "string",
					"enumerable": false,
					"description": "\t 支付时间 格式：yyyy-MM-dd HH:mm:ss"
				},
				{
					"name": "payment_code",
					"type": "string",
					"enumerable": false,
					"description": "\t 支付方式编码"
				},
				{
					"name": "payment_id",
					"type": "string",
					"enumerable": false,
					"description": "支付单ID"
				},
				{
					"name": "seller_account",
					"type": "string",
					"enumerable": false,
					"description": "卖家收款帐号"
				},
				{
					"name": "status",
					"type": "string",
					"enumerable": false,
					"description": "\t 付款单状态"
				},
				{
					"name": "t_begin",
					"type": "string",
					"enumerable": false,
					"description": "\t 开始支付时间"
				},
				{
					"name": "tid",
					"type": "string",
					"enumerable": false,
					"description": "订单ID"
				}
			]
		},
		{
			"name": "receiver",
			"params": [
				{
					"name": "receiver_address",
					"type": "string",
					"enumerable": false,
					"description": "收货人所在详细地址"
				},
				{
					"name": "receiver_city",
					"type": "string",
					"enumerable": false,
					"description": "收货人所在城市"
				},
				{
					"name": "receiver_district",
					"type": "string",
					"enumerable": false,
					"description": "收货人所在城市"
				},
				{
					"name": "receiver_mobile",
					"type": "string",
					"enumerable": false,
					"description": "收货人所在区"
				},
				{
					"name": "receiver_name",
					"type": "string",
					"enumerable": false,
					"description": "收货人姓名"
				},
				{
					"name": "receiver_phone",
					"type": "string",
					"enumerable": false,
					"description": "收货人手机号"
				},
				{
					"name": "receiver_state",
					"type": "string",
					"enumerable": false,
					"description": "收货人所在省"
				},
				{
					"name": "receiver_zip",
					"type": "string",
					"enumerable": false,
					"description": "收货人邮编"
				},
				{
					"name": "tid",
					"type": "string",
					"enumerable": false,
					"description": "订单ID"
				}
			]
		},
		{
			"name": "refund",
			"params": [
				{
					"name": "application_type",
					"type": "string",
					"enumerable": false,
					"description": "customer, bshop, supplier"
				},
				{
					"name": "created",
					"type": "datetime",
					"enumerable": false,
					"description": ""
				},
				{
					"name": "modified",
					"type": "datetime",
					"enumerable": false,
					"description": ""
				},
				{
					"name": "refund_fee",
					"type": "string",
					"enumerable": false,
					"description": "退款金额"
				},
				{
					"name": "refund_id",
					"type": "string",
					"enumerable": false,
					"description": "退款ID"
				},
				{
					"name": "refund_note",
					"type": "string",
					"enumerable": false,
					"description": "退款备注"
				},
				{
					"name": "refund_reason",
					"type": "string",
					"enumerable": false,
					"description": "退款原因"
				},
				{
					"name": "refused_note",
					"type": "string",
					"enumerable": false,
					"description": "拒绝的备注"
				},
				{
					"name": "refused_time",
					"type": "datetime",
					"enumerable": false,
					"description": "拒绝时间"
				},
				{
					"name": "status",
					"type": "string",
					"enumerable": false,
					"description": "\"apply\", \"refused\" , \"refunding\",\"refunded\", \"partially_refunded\", \"cancelled\", \"closed\""
				},
				{
					"name": "t_begin",
					"type": "datetime",
					"enumerable": false,
					"description": "发起时间"
				},
				{
					"name": "t_sent",
					"type": "datetime",
					"enumerable": false,
					"description": " 同意时间"
				},
				{
					"name": "tid",
					"type": "string",
					"enumerable": false,
					"description": "订单ID"
				}
			]
		},
		{
			"name": "shipping",
			"params": [
				{
					"name": "company_code",
					"type": "string",
					"enumerable": false,
					"description": "快递公司编码"
				},
				{
					"name": "company_name",
					"type": "string",
					"enumerable": false,
					"description": "快递公司名"
				},
				{
					"name": "created",
					"type": "string",
					"enumerable": false,
					"description": "创建时间"
				},
				{
					"name": "is_no_express",
					"type": "string",
					"enumerable": false,
					"description": "是否无需物流 true无需物流"
				},
				{
					"name": "item_list",
					"type": "shipping_item",
					"enumerable": false,
					"description": "发货单，发货详情"
				},
				{
					"name": "logistics_no",
					"type": "string",
					"enumerable": false,
					"description": "快递单号"
				},
				{
					"name": "modified",
					"type": "string",
					"enumerable": false,
					"description": "修改时间"
				},
				{
					"name": "shipping_id",
					"type": "string",
					"enumerable": false,
					"description": "发货单ID"
				},
				{
					"name": "tid",
					"type": "string",
					"enumerable": false,
					"description": "订单ID"
				}
			]
		},
		{
			"name": "shipping_item",
			"params": [
				{
					"name": "num",
					"type": "string",
					"enumerable": false,
					"description": "数量"
				},
				{
					"name": "oid",
					"type": "string",
					"enumerable": false,
					"description": "子订单号"
				},
				{
					"name": "shipping_id",
					"type": "string",
					"enumerable": false,
					"description": "发货单号"
				},
				{
					"name": "sku_id",
					"type": "string",
					"enumerable": false,
					"description": "SKU的ID"
				}
			]
		},
		{
			"name": "trade",
			"params": [
				{
					"name": "buyer_memo",
					"type": "string",
					"enumerable": false,
					"description": "购买者备注"
				},
				{
					"name": "cancel_time",
					"type": "datetime",
					"enumerable": false,
					"description": "订单取消时间"
				},
				{
					"name": "close_time",
					"type": "datetime",
					"enumerable": false,
					"description": "订单关闭时间"
				},
				{
					"name": "commission_fee",
					"type": "string",
					"enumerable": false,
					"description": "返佣的金额"
				},
				{
					"name": "consign_time",
					"type": "datetime",
					"enumerable": false,
					"description": "发货时间"
				},
				{
					"name": "created",
					"type": "datetime",
					"enumerable": false,
					"description": "订单创建时间"
				},
				{
					"name": "daixiao_id",
					"type": "string",
					"enumerable": false,
					"description": "相关代销单号"
				},
				{
					"name": "end_time",
					"type": "number",
					"enumerable": false,
					"description": "订单完成时间"
				},
				{
					"name": "has_invoice",
					"type": "string",
					"enumerable": false,
					"description": "是否有发票信息"
				},
				{
					"name": "has_refund",
					"type": "string",
					"enumerable": false,
					"description": "是否退款"
				},
				{
					"name": "invoice",
					"type": "invoice",
					"enumerable": false,
					"description": "发票信息"
				},
				{
					"name": "is_split",
					"type": "string",
					"enumerable": false,
					"description": "是否拆单发货"
				},
				{
					"name": "items_num",
					"type": "string",
					"enumerable": false,
					"description": "子订单个数"
				},
				{
					"name": "modified",
					"type": "datetime",
					"enumerable": false,
					"description": "订单上次修改时间"
				},
				{
					"name": "order_items",
					"type": "trade_item",
					"enumerable": false,
					"description": "子订单"
				},
				{
					"name": "payments",
					"type": "payment",
					"enumerable": false,
					"description": "支付信息"
				},
				{
					"name": "pic_path",
					"type": "string",
					"enumerable": false,
					"description": "订单主图"
				},
				{
					"name": "receiver",
					"type": "receiver",
					"enumerable": false,
					"description": "收货人"
				},
				{
					"name": "refund",
					"type": "refund",
					"enumerable": false,
					"description": "退款信息"
				},
				{
					"name": "shipping_fee",
					"type": "string",
					"enumerable": false,
					"description": "运费"
				},
				{
					"name": "shippings",
					"type": "shipping",
					"enumerable": false,
					"description": "发货信息"
				},
				{
					"name": "status",
					"type": "string",
					"enumerable": false,
					"description": "订单状态 TRADE_CLOSED：交易关闭 TRADE_FINISHED：交易成功 WAIT_BUYER_CONFIRM_GOODS：等待买家确认收货 WAIT_BUYER_PAY：等待买家付款 WAIT_SELLER_SEND_GOODS：等待卖家发货  SELLER_CONSIGNED_PART：卖家部分发货"
				},
				{
					"name": "supplier_memo",
					"type": "string",
					"enumerable": false,
					"description": "供应商备注"
				},
				{
					"name": "tid",
					"type": "string",
					"enumerable": false,
					"description": "订单号"
				},
				{
					"name": "title",
					"type": "string",
					"enumerable": false,
					"description": "订单标题"
				},
				{
					"name": "total_goods_fee",
					"type": "string",
					"enumerable": false,
					"description": "去除运费的订单总金额"
				},
				{
					"name": "total_items_fee",
					"type": "string",
					"enumerable": false,
					"description": "子订单加一起的金额"
				},
				{
					"name": "total_trade_fee",
					"type": "string",
					"enumerable": false,
					"description": "订单应付的金额"
				},
				{
					"name": "trade_adjust_price",
					"type": "string",
					"enumerable": false,
					"description": "订单调整的金额"
				},
				{
					"name": "trade_type",
					"type": "string",
					"enumerable": false,
					"description": "订单类型 for_b：大B代小b b_self：小b采购 c_self：c购买 b_for_c：小b代c购买"
				}
			]
		},
		{
			"name": "trade_item",
			"params": [
				{
					"name": "adjust_price",
					"type": "string",
					"enumerable": false,
					"description": "调整的价格"
				},
				{
					"name": "iid",
					"type": "string",
					"enumerable": false,
					"description": "商品id"
				},
				{
					"name": "num",
					"type": "string",
					"enumerable": false,
					"description": "包含商品的个数"
				},
				{
					"name": "oid",
					"type": "string",
					"enumerable": false,
					"description": "子订单号"
				},
				{
					"name": "pic_path",
					"type": "string",
					"enumerable": false,
					"description": "主图"
				},
				{
					"name": "price",
					"type": "string",
					"enumerable": false,
					"description": "商品价格"
				},
				{
					"name": "sale_price",
					"type": "string",
					"enumerable": false,
					"description": "售价"
				},
				{
					"name": "sku_code",
					"type": "string",
					"enumerable": false,
					"description": ""
				},
				{
					"name": "sku_id",
					"type": "string",
					"enumerable": false,
					"description": "规格id"
				},
				{
					"name": "sku_properties",
					"type": "string",
					"enumerable": false,
					"description": "规格列表"
				},
				{
					"name": "tid",
					"type": "string",
					"enumerable": false,
					"description": "订单号"
				},
				{
					"name": "title",
					"type": "string",
					"enumerable": false,
					"description": "子订单标题"
				},
				{
					"name": "weight",
					"type": "number",
					"enumerable": false,
					"description": "重量"
				}
			]
		},
		{
			"name": "value_added_tax",
			"params": [
				{
					"name": "bank_account",
					"type": "string",
					"enumerable": false,
					"description": "银行账号"
				},
				{
					"name": "company_name",
					"type": "string",
					"enumerable": false,
					"description": "单位名称"
				},
				{
					"name": "deposit_bank",
					"type": "string",
					"enumerable": false,
					"description": "开户银行"
				},
				{
					"name": "registered_addr",
					"type": "string",
					"enumerable": false,
					"description": "注册地址"
				},
				{
					"name": "registered_tel",
					"type": "string",
					"enumerable": false,
					"description": "注册电话"
				},
				{
					"name": "taxpayer_identity",
					"type": "string",
					"enumerable": false,
					"description": "纳税人识别号"
				}
			]
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/data/api/wdwd.trade.close.json
 ** module id = 532
 ** module chunks = 1
 **/